import { createContext, useReducer } from "react";


export const ContentsContext = createContext()

export const contentsReducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_CONTENTS':
   
            return {
                contents: action.payload
            }
        case 'CREATE_CONTENTS':
            return {
                contents: [action.payload, ...state.contents]
            }
        case 'DELETE_CONTENTS':
            return {
                contents: state.contents.filter((c) => c.uuid !== action.payload.uuid)
            }
            case 'DELETE_IMAGE_CONTENTS':
                return {
                    contents: state.contents.filter((c) => c.name !== action.payload.name)
                }
                case 'DELETE_AUDIO_CONTENTS':
           
                return {
                        contents: state.contents.filter((c) => c.name !== action.payload.name)
                    }
        default:
            return state
    }
}


export const ContentsContextProvider = ({ children }) => {

    const [state, dispatchcontent] = useReducer(contentsReducer, {
        contents: null
    })



    return (
        <ContentsContext.Provider value={{ ...state, dispatchcontent }}>
            {children}
        </ContentsContext.Provider>
    )
}